import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Dropdown,
  DropdownItem,
} from '@genie-ui/react';
import './team-management-menu.scss';

function TeamManagementMenu({
  options,
  className = '',
  role,
  setRole = null,
  onOpen = null,
  closedEvent = null,
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const handleDropdownOpenedEvent = () => {
    setOpen(true);
    if (onOpen) {
      onOpen();
    }
  };

  const onItemSelect = (e, item) => {
    setOpen(false);
    e?.preventDefault();
    setRole(item);
  };

  return (
    <div className={`team-management-menu ${className}`}>
      <Dropdown
        id="questionId"
        classNameRoot={`team-management-menu__dropdown ${disabled ? 'team-management-menu__disabled' : ''}`}
        className="team-management-menu__dropdownMenu"
        classNameContainer="team-management-menu__dropdown--container"
        openedEvent={handleDropdownOpenedEvent}
        open={open}
        menuNode={role}
        closedEvent={closedEvent}
      >
        {options.map((item) => (
          <DropdownItem
            key={item}
            className="apollo-c-multi-select-dropdown__dropdownItem"
            onClick={(e) => onItemSelect(e, item)}
          >
            <Typography variant="body1">{item}</Typography>
          </DropdownItem>
        ))}
      </Dropdown>
    </div>
  );
}

TeamManagementMenu.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  className: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  setRole: PropTypes.func.isRequired,
  closedEvent: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

TeamManagementMenu.defaultProps = {
  disabled: false,
};

export default TeamManagementMenu;
